module.exports = __webpack_public_path__ + "media/images/telefono_corona1-9d1cd01ac6a722bc692dd2258c7abb79.png";